module.exports = __webpack_public_path__ + "img/hpt.16b38183.gif";